<template>
  <v-tooltip top>
    <template #activator="{on}">
      <v-icon :color="color ? color: undefined"
              class="mr-1 subscription-lock-icon"
              @click.stop
              v-on="on">mdi-lock
      </v-icon>
    </template>
    <div>Nicht verfügbar</div>
  </v-tooltip>
</template>

<script>
export default {
  name: "FinSubscriptionLock",
  props: {
    color: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped>

</style>
